import React from "react";
import { Link } from "react-router-dom";
import Tooltip from "../Tooltip/Tooltip";
import "./NavigationBreadcrumbs.scss";

export interface NavigationBreadcrumbItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
}

export interface NavigationBreadcrumbsProps {
  items: NavigationBreadcrumbItem[];
  className?: string;
  "data-testid"?: string;
}

const NavigationBreadcrumbs: React.FC<NavigationBreadcrumbsProps> = ({
  items,
  className = "",
  "data-testid": dataTestId,
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={`navigation-breadcrumbs ${className}`}
      data-testid={dataTestId}
    >
      <ol className="navigation-breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          const crumbContent = (
            <>
              {!!item.icon && (
                <span className="navigation-breadcrumbs-icon">{item.icon}</span>
              )}
              <Tooltip content={item.label} type="ellipsis">
                <span className="navigation-breadcrumbs-label">
                  {item.label}
                </span>
              </Tooltip>
            </>
          );

          return (
            <li
              className="navigation-breadcrumbs-item"
              key={`${index}-${item.label}`}
            >
              {index > 0 && (
                <span
                  className="navigation-breadcrumbs-separator"
                  aria-hidden="true"
                >
                  /
                </span>
              )}
              {!isLast && item.href ? (
                <Link to={item.href} className="navigation-breadcrumbs-link">
                  {crumbContent}
                </Link>
              ) : (
                <span
                  className="navigation-breadcrumbs-current"
                  aria-current={isLast ? "page" : undefined}
                >
                  {crumbContent}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default NavigationBreadcrumbs;
